import { create } from "zustand";

interface DateRange {
  from: Date | undefined;
  to?: Date | undefined;
}

type SelectRangeEventHandler = (range: DateRange | undefined) => void;

interface DateRangeState {
  dateRange: DateRange;
  setDateRange: SelectRangeEventHandler;
}

export const useDateRangeStore = create<DateRangeState>()((set) => ({
  dateRange: {
    from: new Date(),
    to: new Date(),
  },
  setDateRange: (range) => {
    // Your logic for updating the date range here
    // For simplicity, we'll just directly set the range
    set({ dateRange: range });
  },
}));
